import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";

const CONTACT_EMAIL = "contact@faanuu.app";

export default function DataDeletion() {
  return (
    <div className="min-h-screen bg-tribal">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 py-12 fade-up">
        <p className="text-xs tracking-[0.3em] text-[color:var(--primary)] mb-3">LÉGAL</p>
        <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight mb-2">Suppression des données utilisateur</h1>
        <p className="text-sm text-[color:var(--text-secondary)] mb-8">
          Comment demander l&apos;effacement de votre compte et de vos données sur Faanuu
        </p>

        <div className="glass rounded-lg p-6 sm:p-8 space-y-8 text-sm sm:text-base text-[color:var(--text-secondary)] leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-[color:var(--text-primary)] mb-2">1. Données concernées</h2>
            <p>La suppression de votre compte entraîne l&apos;effacement ou l&apos;anonymisation de :</p>
            <ul className="list-disc list-inside space-y-1 ml-1 mt-2">
              <li>votre profil (e-mail, nom, pseudo, photo) ;</li>
              <li>vos statistiques et historique de parties ;</li>
              <li>vos messages de chat et signalements associés à votre compte.</li>
            </ul>
            <p className="mt-2 text-xs">
              Certaines données peuvent être conservées de façon anonyme à des fins statistiques (ex. nombre total de parties jouées), sans permettre de vous identifier.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[color:var(--text-primary)] mb-2">2. Demande par e-mail</h2>
            <p>
              Envoyez un e-mail à{" "}
              <a href={`mailto:${CONTACT_EMAIL}?subject=Suppression%20de%20mon%20compte%20Faanuu`} className="text-[color:var(--primary)] hover:underline font-medium">{CONTACT_EMAIL}</a>{" "}
              depuis l&apos;adresse e-mail liée à votre compte, avec pour objet <strong className="text-[color:var(--text-primary)]">« Suppression de mon compte Faanuu »</strong>.
            </p>
            <p className="mt-2">Précisez l&apos;adresse e-mail de votre compte Faanuu.</p>
            <p className="mt-3">
              Nous traiterons votre demande dans un délai maximal de <strong className="text-[color:var(--text-primary)]">30 jours</strong> et vous confirmerons la suppression par e-mail.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[color:var(--text-primary)] mb-2">3. Données que vous pouvez modifier vous-même</h2>
            <p>
              Sans supprimer tout le compte, vous pouvez depuis{" "}
              <Link to="/profile" className="text-[color:var(--primary)] hover:underline">Mon compte</Link> :
            </p>
            <ul className="list-disc list-inside space-y-1 ml-1 mt-2">
              <li>modifier ou supprimer votre pseudo, nom et photo ;</li>
              <li>changer votre mot de passe (compte e-mail).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[color:var(--text-primary)] mb-2">4. Réclamation</h2>
            <p>
              Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de l&apos;autorité de protection des données compétente dans votre pays de résidence.
            </p>
          </section>

          <section className="rounded-lg border border-[color:var(--primary)]/30 bg-[color:var(--primary)]/5 p-4">
            <h2 className="text-base font-semibold text-[color:var(--text-primary)] mb-2">Contact rapide</h2>
            <p>
              E-mail :{" "}
              <a href={`mailto:${CONTACT_EMAIL}?subject=Suppression%20de%20mon%20compte%20Faanuu`} className="text-[color:var(--primary)] hover:underline font-medium">{CONTACT_EMAIL}</a>
            </p>
          </section>
        </div>

        <p className="mt-8 text-center text-xs text-[color:var(--text-secondary)]">
          <Link to="/politique-confidentialite" className="text-[color:var(--primary)] hover:underline">Politique de confidentialité</Link>
          {" · "}
          <Link to="/" className="hover:underline">Accueil</Link>
        </p>
      </main>
    </div>
  );
}
